import config from '@/config';
import request from '@/common/request.js';
import common from '@/common/common.js';
import utils from '@/common/utils.js';
// import ws from '@/common/websocket.js'
import lazy from '@/common/lazy.js'
import site from '@/common/site.js'
export default {
	install(Vue) {
		Vue.use(config)
		Vue.use(utils)
		Vue.use(common)
		Vue.use(request)
		// Vue.use(ws)
		Vue.use(lazy)
		Vue.use(site)
	}
}

